import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Modal } from "bootstrap"; // Import the Modal class from Bootstrap
import appStore from "../../assets/images/appstore-light.svg"
import playStore from "../../assets/images/googleplay-light.svg"

const DownloadApp = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hovered,setHovered]=useState("");

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 200) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
        setHovered("");
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // const scrollToTop = () => {
  //   window.scrollTo({
  //     top: 0,
  //     behavior: "smooth",
  //   });
  // };

  useEffect(() => {
    // Initialize the Bootstrap modal after the component mounts
    const modalElement = document.getElementById("exampleModal");
    const myModal = new Modal(modalElement);

    // Clean up on component unmount
    return () => {
      myModal.dispose();
    };
  }, []);

  return (
    <div className="download-app">
      <div>
        {isVisible && (
          <button   
            onMouseEnter={()=>setHovered(true)}
            onMouseLeave={()=>setHovered(false)}
            type="button"
            className="btn btn-primary modal-btn"
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"
          >
        {hovered? <div className="download-text">Mobile App Download</div>:
          <svg className={`${hovered!=="" ? 'download-svg' : ''}`} width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 9.00195C19.175 9.01406 20.3529 9.11051 21.1213 9.8789C22 10.7576 22 12.1718 22 15.0002V16.0002C22 18.8286 22 20.2429 21.1213 21.1215C20.2426 22.0002 18.8284 22.0002 16 22.0002H8C5.17157 22.0002 3.75736 22.0002 2.87868 21.1215C2 20.2429 2 18.8286 2 16.0002L2 15.0002C2 12.1718 2 10.7576 2.87868 9.87889C3.64706 9.11051 4.82497 9.01406 7 9.00195" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <path d="M12 2L12 15M12 15L9 11.5M12 15L15 11.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
         }
          </button>
        )}
        <div
          className="modal fade"
          id="exampleModal"
          tabIndex={-1}
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Download Mobile App
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <div
                  className="slider-btn btn-container wow animate__fadeInUp"
                  data-wow-duration="1.2s"
                >
                  <a href="https://apps.apple.com/us/app/your-french-teachers/id6742703203"  target="_blank" className="btn btn-dark btn-lg px-3 py-2">
                    <img
                      src={appStore}
                      className="light-mode-img"
                      width={124}
                      alt="App Store"
                    />
                  </a>
                  <a href="https://play.google.com/store/apps/details?id=com.khinezin.yftapp"  target="_blank" className="btn btn-dark btn-lg px-3 py-2">
                    <img
                      src={playStore}
                      className="light-mode-img"
                      width={139}
                      alt="Google Play"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadApp;
